<script setup lang="ts">

import {computed} from "vue";
import PaparaLogo from "./papara.svg"

const props = defineProps({
  height: {
    type: Number,
    default: 41
  },

})

const height = computed(() => props.height)
const width = computed(() => props.height * 94 / 26)
</script>

<template>
  <img :src="PaparaLogo" :width="width" :height="height"/>
</template>

<style scoped lang="less">

</style>
